"use strict";import{tag as t}from"../custom-tag.js";export function subscribeBellIcon({height:e=16,width:l=16,hidden:s=!1,title:r="Subscribe bell"}={}){return t`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${s?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <mask
        id="subscribe-bell_svg__mask0_6875_6556"
        width="17"
        height="20"
        x="4"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="transparent"
          stroke="currentColor"
          d="M17.902 15.846v.204l.142.145 1.858 1.906v.322h-15v-.322l1.858-1.906.142-.145v-5.332c0-2.994 1.53-5.367 4.118-5.996l.382-.093V3.538c0-.587.458-1.038 1-1.038s1 .451 1 1.038V4.63l.382.093c2.579.628 4.118 3.013 4.118 5.996zm-4.08 4.603c-.204.614-.772 1.051-1.42 1.051a1.51 1.51 0 0 1-1.42-1.051z"
        />
      </mask>
      <g mask="url(#subscribe-bell_svg__mask0_6875_6556)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=subscribeBell.js.map
